import { render, staticRenderFns } from "./SequenceDetail.vue?vue&type=template&id=336507e2&scoped=true"
import script from "./SequenceDetail.vue?vue&type=script&lang=js"
export * from "./SequenceDetail.vue?vue&type=script&lang=js"
import style0 from "./SequenceDetail.vue?vue&type=style&index=0&id=336507e2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336507e2",
  null
  
)

export default component.exports